import { trackCdp } from './tracking.js';
import { getCategory, getDynamicVariation, getSubcategory, getLocation, getNavDeviceType, isNavSticky, } from './trackingUtils.js';
export function trackLinkClick(element, data = {}) {
    const onClick = () => {
        trackCdp({
            eventName: 'Click Top Navigation Link',
            properties: {
                linkId: data.id,
                linkText: data.title,
                linkUrl: data.url.includes('http') ? data.url : `${window.location.origin}${data.url}`,
                linkCategory: getCategory(element),
                linkSubcategory: getSubcategory(element),
                linkLocation: getLocation(element),
                navDeviceType: getNavDeviceType(element),
                isNavSticky: isNavSticky(element),
                dynamicVariation: getDynamicVariation(element),
            },
        });
    };
    element.addEventListener('click', onClick);
    return {
        // Updates the data object used in the action whenever the data parameter is changed
        update(updatedData) {
            data = updatedData;
        },
        destroy() {
            element.removeEventListener('click', onClick);
        },
    };
}
